import ReactDOM from 'react-dom/client';
import App from './App';
import { UserProvider } from 'context/UserContext';
import { ThemeProvider } from 'context/ThemeContext';
import { LanguageProvider } from 'context/LanguageContext';
import { TimezoneProvider } from 'context/TimezoneContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <LanguageProvider>
        <TimezoneProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </TimezoneProvider>
      </LanguageProvider>
    </ThemeProvider>
  </QueryClientProvider>
);
